import styled, { css } from 'styled-components';

interface Props {
  size?: 'small' | 'large';
  backgroundColor?: string;
}

export const IconBlock = styled.div<Props>`
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ backgroundColor }) => backgroundColor || '#d83426'};
  svg {
    color: var(--text-white);
    /* path {
      fill: var(--text-white);
    }
    path {
      stroke: var(--text-white);
    } */
  }
  ${({ size }) =>
    size === 'small' &&
    css`
      width: 26px;
      height: 26px;
      border-radius: 6px;
    `}
  ${({ size }) =>
    size === 'large' &&
    css`
      width: 32px;
      height: 32px;
      border-radius: 8px;
    `}
`;
